module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile-detail/profile-detail.component.sass
// module id = ./src/app/profile/profile-detail/profile-detail.component.sass
// module chunks = main